import { Lesson } from '@/models/Lesson';
import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { CourseStudentView } from '../list/types';
import { StudentListData, StudentState, StudentTypes } from './types';

const INITIAL_DATA: StudentListData = {
    courseStudentView: { course: { lessons: [] as Lesson[] } } as CourseStudentView,
    loading: false,
    success: false,
    hasError: false,
    reorderSucess: false,
};

const INITIAL_STATE: StudentState = {
    myListData: INITIAL_DATA,
};

const reducer: Reducer<StudentState> = (state: StudentState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case StudentTypes.GET_ADDED_CONTENT_LIST_REQUEST:
            return { ...state, myListData: { ...state.myListData, loading: true } };
        case StudentTypes.GET_ADDED_CONTENT_LIST_SUCCESS:
            return {
                ...state,
                myListData: {
                    ...state.myListData,
                    success: true,
                    loading: false,
                    courseStudentView: { ...action.payload.data },
                },
            };
        case StudentTypes.GET_ADDED_CONTENT_LIST_CLEAR:
            return {
                ...state,
                myListData: INITIAL_DATA,
            };

        case StudentTypes.GET_ADDED_CONTENT_LIST_FAILURE:
            return { ...state, myListData: { ...state.myListData, loading: false, hasError: true } };
        case StudentTypes.ADD_CONTENT_TO_COURSE_REQUEST:
            return { ...state, myListData: { ...state.myListData, loading: true, success: false } };

        case StudentTypes.ADD_CONTENT_TO_COURSE_SUCCESS:
            return {
                ...state,
                myListData: { ...state.myListData, success: true, loading: false },
            };
        case StudentTypes.ADD_CONTENT_TO_COURSE_FAILURE:
            return {
                ...state,
                myListData: {
                    ...state.myListData,
                    loading: false,
                    addContentToCourseSuccess: false,
                    hasError: true,
                },
            };

        case StudentTypes.DELETE_CONTENT_FROM_COURSE_REQUEST:
            return { ...state, myListData: { ...state.myListData, loading: true } };
        case StudentTypes.DELETE_CONTENT_FROM_COURSE_SUCCESS:
            const { lessonId } = action.payload;
            const addedLessons = [...(state.myListData.courseStudentView.course.lessons || [])];
            const i = addedLessons.findIndex((l: Lesson) => l.id === lessonId);
            addedLessons.splice(i, 1);

            return {
                ...state,
                myListData: {
                    ...state.myListData,
                    success: true,
                    loading: false,
                    courseStudentView: {
                        ...state.myListData.courseStudentView,
                        course: {
                            ...state.myListData.courseStudentView.course,
                            lessons: addedLessons,
                        },
                    },
                },
            };
        case StudentTypes.DELETE_CONTENT_FROM_COURSE_FAILURE:
            return {
                ...state,
                myListData: { ...state.myListData, hasError: true, loading: false },
            };
        case StudentTypes.REORDER_CONTENT_LIST_REQUEST:
            return { ...state, myListData: { ...state.myListData, hasError: false, success: false, loading: false } };
        case StudentTypes.REORDER_CONTENT_LIST_SUCCESS:
            return { ...state, myListData: { ...state.myListData, hasError: false, success: true, loading: false } };

        case StudentTypes.REORDER_CONTENT_LIST_FAILURE:
            return { ...state, myListData: { ...state.myListData, hasError: true, success: false, loading: false } };

        case StudentTypes.SET_ADDED_CONTENT_LIST:
            return {
                ...state,
                myListData: {
                    ...state.myListData,
                    courseStudentView: {
                        ...state.myListData.courseStudentView,
                        course: {
                            ...state.myListData.courseStudentView.course,
                            lessons: action.payload,
                        },
                    },
                },
            };
        default:
            return state;
    }
};

export default reducer;
